export const shellBannerWrapperCss = "ss39kf7";
export const shellBannerCss = "sg2qgig";
export const bannerMessageCss = "biumb3r";

require("./pretendModeShellBannerStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pretendModeShellBannerStyles.ts");